import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { RemoteData } from 'rf-comp';
import {
  Page, H1, Button
} from 'rf-ui';
import * as a from './actions';
import Statistics from './GroupStatistics';

const StatisticsPageForGroup = ({ ...props }) => {
  const { id } = useParams();

  const history = useHistory();

  useEffect(() => {
    props.fetchGroupDetails(id);
  }, []);

  return (
    <Page>
      <RemoteData
          type={props.groupDetailsState}
          loading={() => <H1>Henter gruppedetaljer...</H1>}
          failure={err => <span>Feil: {err.message}</span>}
          success={group => (
            <>
              <H1>Statistikk for {group.groupName}</H1>
              <Statistics
                games={group.games}
                players={group.players}
                groupId={group.id} />
            </>
          )}
      />
      <Button onClick={() => history.push('/groups/')} title="Tilbake til gruppeliste" />
    </Page>
  );
};

StatisticsPageForGroup.propTypes = {
  groupDetailsState: PropTypes.object.isRequired,
  fetchGroupDetails: PropTypes.func.isRequired,
};

const mapStateToProps = ({ statisticsPageForGroup }) => ({
  groupDetailsState: statisticsPageForGroup.groupDetailsState,
});

const mapDispatchToProps = dispatch => ({
  fetchGroupDetails: a.getGroupDetails(dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StatisticsPageForGroup);
